export const SET_ACCOUNT = 'SET_ACCOUNT';

export function setAccountInfo(payload) {
  return { type: SET_ACCOUNT, payload };
}
